import { render, staticRenderFns } from "./liaison.vue?vue&type=template&id=a1994026&scoped=true&"
import script from "./liaison.vue?vue&type=script&lang=tsx&"
export * from "./liaison.vue?vue&type=script&lang=tsx&"
import style0 from "./liaison.vue?vue&type=style&index=0&id=a1994026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1994026",
  null
  
)

export default component.exports